// extracted by css-extract-rspack-plugin
export default {"WidgetLabel":"Widget-module__WidgetLabel___wCXcn","Footer":"Widget-module__Footer___Sm6xV"};